export default "__VITE_ASSET__BQgnDAby__"